export default __webpack_public_path__ + "static/media/video.1029cd75.jpeg";